/**
 * Enrich test cases with resolved risk names from the register.
 * Test cases and risks use real UUID `id` values and display names only.
 */

/**
 * Decorate test cases with `riskName` when missing on the row.
 * `testCases` should be the pool being displayed; `risks` is the project register.
 */
export function numberTestCases(testCases = [], risks = []) {
  const riskById = new Map(risks.map((r) => [r.id, r]));

  return testCases.map((tc) => ({
    ...tc,
    riskName: riskById.get(tc.riskId)?.name || tc.riskName || "",
  }));
}
